import {
  Component,
  inject,
  Renderer2,
  DOCUMENT,
  ChangeDetectionStrategy,
} from '@angular/core';
import { environment } from '../../../environments/environment';
import {
  PublicToolbarConfig,
  PublicToolbarService,
} from '../../services/public-toolbar.service';
import { Observable, map, startWith } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { MatToolbar } from '@angular/material/toolbar';
import { MatAnchor } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NavigationComponent } from './components/navigation/navigation.component';
import { PressableComponent } from './components/pressable/pressable.component';
import { Router, RouterLink, NavigationEnd } from '@angular/router';
import { BurgerComponent } from './components/burger/burger.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { filter } from 'rxjs/operators';

/** Login, sign-up and password pages: reduced header and the slim footer. */
export const AUTH_ROUTE =
  /^\/(login|signup|password-forget|reset-password)(\/|\?|#|;|$)/;

@Component({
  selector: 'app-public-toolbar',
  templateUrl: './public-toolbar.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatToolbar,
    MatAnchor,
    MatIcon,
    NavigationComponent,
    PressableComponent,
    RouterLink,
    BurgerComponent,
    DropdownComponent,
    AsyncPipe,
  ],
})
export class PublicToolbarComponent {
  config$: Observable<PublicToolbarConfig>;
  /** Login and sign-up flows show only the logo and a way back to the website. */
  isAuthRoute$: Observable<boolean>;

  baseUrl = environment.homepageBaseUrl;
  mobileMenuIsOpen = false;

  private readonly renderer = inject(Renderer2);
  private readonly document = inject(DOCUMENT);
  private readonly router = inject(Router);

  constructor() {
    const toolbarService = inject(PublicToolbarService);

    this.config$ = toolbarService.config$;
    const isAuth = (url: string) => AUTH_ROUTE.test(url);
    this.isAuthRoute$ = this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(e => isAuth(e.urlAfterRedirects)),
      startWith(isAuth(this.router.url))
    );
  }

  toggleMobileMenu(isOpen: boolean) {
    this.mobileMenuIsOpen = isOpen;

    if (!isOpen) {
      this.renderer.removeClass(this.document.body, 'menu-is-open');
    } else {
      this.renderer.addClass(this.document.body, 'menu-is-open');
    }
  }

  closeMobileMenu() {
    this.mobileMenuIsOpen = false;
    this.renderer.removeClass(this.document.body, 'menu-is-open');
  }
}
